export default [
  {
    path: '/user/register',
    name: 'register',
    component: () => import('@/views/user/register.vue'),
    meta: { title: '注册' }
  },
  {
    path: '/user/login',
    name: 'login',
    component: () => import('@/views/user/login.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/pay',
    name: 'pay',
    component: () => import('@/views/pay.vue'),
    meta: { title: '支付', requireAuth: true }
  }
]
